"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCodeChallenge = exports.createCodeVerifier = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _nanoid = require("nanoid");
var _base64Arraybuffer = require("base64-arraybuffer");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); } /*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
// Server Side
const randomstring = require('randomstring');

// Globals
const isServer = typeof window === 'undefined';

/**
 * Creates Code Verifier use for PKCE auth flow.
 *
 * @returns {String} The 128 character length code verifier.
 */
const createCodeVerifier = () => {
  return isServer ? randomstring.generate(128) : (0, _nanoid.nanoid)(128);
};

/**
 * Creates Code Challenge based on Code Verifier
 *
 * @param {String} codeVerifier
 * @returns {String}
 */
exports.createCodeVerifier = createCodeVerifier;
const generateCodeChallenge = exports.generateCodeChallenge = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (codeVerifier) {
    let base64Digest;
    if (isServer) {
      yield Promise.resolve().then(() => _interopRequireWildcard(require('crypto'))).then(module => {
        const crypto = module.default;
        base64Digest = crypto.createHash('sha256').update(codeVerifier).digest('base64');
      });
    } else {
      const encoder = new TextEncoder();
      const data = encoder.encode(codeVerifier);
      const digest = yield window.crypto.subtle.digest('SHA-256', data);
      base64Digest = (0, _base64Arraybuffer.encode)(digest);
    }

    // @ts-ignore
    return base64Digest.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  });
  return function generateCodeChallenge(_x) {
    return _ref.apply(this, arguments);
  };
}();